import { useState, useEffect } from "react";

interface ImageDimensions {
  width: number;
  height: number;
  aspectRatio: number;
  loaded: boolean;
}

export function useImageDimensions(imageUrls: string[]) {
  const [dimensions, setDimensions] = useState<Record<string, ImageDimensions>>(
    {},
  );
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadDimensions = async () => {
      const promises = imageUrls.map((url) => {
        return new Promise<{ url: string; dimensions: ImageDimensions }>(
          (resolve) => {
            const img = new window.Image();
            img.onload = () => {
              resolve({
                url,
                dimensions: {
                  width: img.naturalWidth,
                  height: img.naturalHeight,
                  aspectRatio: img.naturalWidth / img.naturalHeight,
                  loaded: true,
                },
              });
            };
            img.onerror = () => {
              resolve({
                url,
                dimensions: {
                  width: 800,
                  height: 600,
                  aspectRatio: 16 / 9,
                  loaded: false,
                },
              });
            };
            img.src = url;
          },
        );
      });

      const results = await Promise.all(promises);
      const dimensionsMap = results.reduce(
        (acc, { url, dimensions }) => {
          acc[url] = dimensions;
          return acc;
        },
        {} as Record<string, ImageDimensions>,
      );

      setDimensions(dimensionsMap);
      setLoading(false);
    };

    loadDimensions();
  }, [imageUrls]);

  return { dimensions, loading };
}
